// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as BetaRouteImport } from './routes/beta'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthedAdminRouteImport } from './routes/_authed/_admin'
import { Route as InviteIdRouteImport } from './routes/invite.$id'
import { Route as AuthedAppIndexRouteImport } from './routes/_authed/app.index'
import { Route as AuthedAppClassesRouteImport } from './routes/_authed/app.classes'
import { Route as AuthedAdminAdminIndexRouteImport } from './routes/_authed/_admin/admin.index'
import { Route as AuthedAdminAdminAccountsRouteImport } from './routes/_authed/_admin/admin.accounts'
import { Route as AuthedAdminAdminAiRouteImport } from './routes/_authed/_admin/admin.ai'
import { Route as AuthedAdminAdminBetaRouteImport } from './routes/_authed/_admin/admin.beta'
import { Route as AuthedAdminAdminClassesRouteImport } from './routes/_authed/_admin/admin.classes'
import { Route as AuthedAdminAdminEventsRouteImport } from './routes/_authed/_admin/admin.events'
import { Route as AuthedAdminAdminUsersRouteImport } from './routes/_authed/_admin/admin.users'
import { Route as AuthedAppExamsExamIdRouteImport } from './routes/_authed/app.exams.$examId'
import { Route as AuthedAppExamsNewRouteImport } from './routes/_authed/app.exams.new'
import { Route as AuthedAppSettingsAccountRouteImport } from './routes/_authed/app.settings.account'
import { Route as AuthedAppSettingsBillingRouteImport } from './routes/_authed/app.settings.billing'
import { Route as AuthedAppSettingsOrganizationRouteImport } from './routes/_authed/app.settings.organization'
import { Route as AuthedAppSettingsUsageRouteImport } from './routes/_authed/app.settings.usage'
import { Route as AuthedAdminAdminOrganizationsIndexRouteImport } from './routes/_authed/_admin/admin.organizations.index'
import { Route as AuthedAdminAdminOrganizationsOrgIdRouteImport } from './routes/_authed/_admin/admin.organizations.$orgId'
import { Route as AuthedAppExamsExamIdGradingRouteImport } from './routes/_authed/app.exams.$examId_.grading'
import { Route as AuthedAppExamsExamIdPrintRouteImport } from './routes/_authed/app.exams.$examId_.print'
import { Route as AuthedAppExamsExamIdSubmissionsRouteImport } from './routes/_authed/app.exams.$examId_.submissions'
import { Route as AuthedAppExamsExamIdReviewSubmissionIdRouteImport } from './routes/_authed/app.exams.$examId_.review.$submissionId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const BetaRoute = BetaRouteImport.update({
            id: '/beta',path: '/beta',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const AuthedAdminRoute = AuthedAdminRouteImport.update({
            id: '/_admin',getParentRoute: () => AuthedRoute
          })
const InviteIdRoute = InviteIdRouteImport.update({
            id: '/invite/$id',path: '/invite/$id',getParentRoute: () => rootRouteImport
          })
const AuthedAppIndexRoute = AuthedAppIndexRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => AuthedRoute
          })
const AuthedAppClassesRoute = AuthedAppClassesRouteImport.update({
            id: '/app/classes',path: '/app/classes',getParentRoute: () => AuthedRoute
          })
const AuthedAdminAdminIndexRoute = AuthedAdminAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAdminAccountsRoute = AuthedAdminAdminAccountsRouteImport.update({
            id: '/admin/accounts',path: '/admin/accounts',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAdminAiRoute = AuthedAdminAdminAiRouteImport.update({
            id: '/admin/ai',path: '/admin/ai',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAdminBetaRoute = AuthedAdminAdminBetaRouteImport.update({
            id: '/admin/beta',path: '/admin/beta',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAdminClassesRoute = AuthedAdminAdminClassesRouteImport.update({
            id: '/admin/classes',path: '/admin/classes',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAdminEventsRoute = AuthedAdminAdminEventsRouteImport.update({
            id: '/admin/events',path: '/admin/events',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAdminUsersRoute = AuthedAdminAdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAppExamsExamIdRoute = AuthedAppExamsExamIdRouteImport.update({
            id: '/app/exams/$examId',path: '/app/exams/$examId',getParentRoute: () => AuthedRoute
          })
const AuthedAppExamsNewRoute = AuthedAppExamsNewRouteImport.update({
            id: '/app/exams/new',path: '/app/exams/new',getParentRoute: () => AuthedRoute
          })
const AuthedAppSettingsAccountRoute = AuthedAppSettingsAccountRouteImport.update({
            id: '/app/settings/account',path: '/app/settings/account',getParentRoute: () => AuthedRoute
          })
const AuthedAppSettingsBillingRoute = AuthedAppSettingsBillingRouteImport.update({
            id: '/app/settings/billing',path: '/app/settings/billing',getParentRoute: () => AuthedRoute
          })
const AuthedAppSettingsOrganizationRoute = AuthedAppSettingsOrganizationRouteImport.update({
            id: '/app/settings/organization',path: '/app/settings/organization',getParentRoute: () => AuthedRoute
          })
const AuthedAppSettingsUsageRoute = AuthedAppSettingsUsageRouteImport.update({
            id: '/app/settings/usage',path: '/app/settings/usage',getParentRoute: () => AuthedRoute
          })
const AuthedAdminAdminOrganizationsIndexRoute = AuthedAdminAdminOrganizationsIndexRouteImport.update({
            id: '/admin/organizations/',path: '/admin/organizations/',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAdminOrganizationsOrgIdRoute = AuthedAdminAdminOrganizationsOrgIdRouteImport.update({
            id: '/admin/organizations/$orgId',path: '/admin/organizations/$orgId',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAppExamsExamIdGradingRoute = AuthedAppExamsExamIdGradingRouteImport.update({
            id: '/app/exams/$examId_/grading',path: '/app/exams/$examId/grading',getParentRoute: () => AuthedRoute
          })
const AuthedAppExamsExamIdPrintRoute = AuthedAppExamsExamIdPrintRouteImport.update({
            id: '/app/exams/$examId_/print',path: '/app/exams/$examId/print',getParentRoute: () => AuthedRoute
          })
const AuthedAppExamsExamIdSubmissionsRoute = AuthedAppExamsExamIdSubmissionsRouteImport.update({
            id: '/app/exams/$examId_/submissions',path: '/app/exams/$examId/submissions',getParentRoute: () => AuthedRoute
          })
const AuthedAppExamsExamIdReviewSubmissionIdRoute = AuthedAppExamsExamIdReviewSubmissionIdRouteImport.update({
            id: '/app/exams/$examId_/review/$submissionId',path: '/app/exams/$examId/review/$submissionId',getParentRoute: () => AuthedRoute
          })





const AuthedAdminRouteChildren = {
  AuthedAdminAdminAccountsRoute: AuthedAdminAdminAccountsRoute,AuthedAdminAdminAiRoute: AuthedAdminAdminAiRoute,AuthedAdminAdminBetaRoute: AuthedAdminAdminBetaRoute,AuthedAdminAdminClassesRoute: AuthedAdminAdminClassesRoute,AuthedAdminAdminEventsRoute: AuthedAdminAdminEventsRoute,AuthedAdminAdminUsersRoute: AuthedAdminAdminUsersRoute,AuthedAdminAdminIndexRoute: AuthedAdminAdminIndexRoute,AuthedAdminAdminOrganizationsOrgIdRoute: AuthedAdminAdminOrganizationsOrgIdRoute,AuthedAdminAdminOrganizationsIndexRoute: AuthedAdminAdminOrganizationsIndexRoute
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(AuthedAdminRouteChildren)



const AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,AuthedAppClassesRoute: AuthedAppClassesRoute,AuthedAppIndexRoute: AuthedAppIndexRoute,AuthedAppExamsExamIdRoute: AuthedAppExamsExamIdRoute,AuthedAppExamsNewRoute: AuthedAppExamsNewRoute,AuthedAppSettingsAccountRoute: AuthedAppSettingsAccountRoute,AuthedAppSettingsBillingRoute: AuthedAppSettingsBillingRoute,AuthedAppSettingsOrganizationRoute: AuthedAppSettingsOrganizationRoute,AuthedAppSettingsUsageRoute: AuthedAppSettingsUsageRoute,AuthedAppExamsExamIdGradingRoute: AuthedAppExamsExamIdGradingRoute,AuthedAppExamsExamIdPrintRoute: AuthedAppExamsExamIdPrintRoute,AuthedAppExamsExamIdSubmissionsRoute: AuthedAppExamsExamIdSubmissionsRoute,AuthedAppExamsExamIdReviewSubmissionIdRoute: AuthedAppExamsExamIdReviewSubmissionIdRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,BetaRoute: BetaRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,VerifyEmailRoute: VerifyEmailRoute,InviteIdRoute: InviteIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)